// @ts-ignore
import * as aes256 from "aes256";
import Authentication from "../../../domain/authentication/Authentication";
import StorageRepository from "../../../domain/fundamentals/storage/StorageRepository";
import LocalStorageDataSource from "../../../infrastructure/datasource/storage/LocalStorageDataSource";

export default class SaveAuthentication {
  private static ENCRYPT_ID_KEY: string = "auto_login_id";
  private static ENCRYPT_PASSWORD_KEY: string = "auto_login_password";
  private static STORAGE_KEY: string = "autoLoginData";

  constructor(private readonly repository: StorageRepository = new LocalStorageDataSource()) {
  }

  public execute(authentication: Authentication): void {
    const encryptId: string = aes256.encrypt(SaveAuthentication.ENCRYPT_ID_KEY, authentication.loginId.value);
    const encryptPassword: string = aes256.encrypt(SaveAuthentication.ENCRYPT_PASSWORD_KEY, authentication.loginPassword.value);
    this.repository.save(SaveAuthentication.STORAGE_KEY, JSON.stringify({
      id: encryptId,
      password: encryptPassword,
    }));
  }
}